import styles from "./styles.module.scss";
import { ETypes, FC, Props } from "./typings";
import LeftArrow from "assets/icons/left-arrow.svg?react";
import PIIcon from "assets/icons/filters/pi.svg?react";
import EmailIcon from "assets/icons/filters/email.svg?react";
import CalendarIcon from "assets/icons/calendar.svg?react";
import LetterIcon from "assets/icons/filters/editor.svg?react";
import AllIcon from "assets/icons/filters/all.svg?react";
import FKIcon from "assets/icons/filters/credit.svg?react";
import PolandIcon from "assets/icons/filters/poland.svg?react";
import ImapIcon from "assets/icons/filters/imap.svg?react";
import OutlookIcon from "assets/icons/filters/outlook.svg?react";
import GmailIcon from "assets/icons/filters/Gmail.svg?react";
import MicrosoftIcon from "assets/icons/filters/Microsoft.svg?react";
import GoogleIcon from "assets/icons/filters/Google.svg?react";
import AppleIcon from "assets/icons/apple.svg?react";
import WordIcon from "assets/icons/filters/word.svg?react";
import DocsIcon from "assets/icons/filters/docs.svg?react";
import KsefIcon from "assets/icons/ksef.svg?react";
import { useContext, useState } from "react";
import { IntegrationProvider } from "dto/Settings/IntegrationProvider";
import { IntegrationType } from "dto/Settings/IntegrationType";
import ConfigureIMAP from "components/ConfigureIMAP";
import CourtPortalSettings from "../CourtPortalSettings";
import { logger } from "utils/logger";
import ConfigureAppleCalendar from "components/ConfigureAppleCalendar";
import ConfigureKSeF from "components/ConfigureKSeF";
import ConfigureCru from "components/ConfigureCru";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileContract } from "@fortawesome/free-solid-svg-icons";
import { AbilityContext } from "contexts/AbilityContext";
import { useTranslation } from "react-i18next";

export interface IApplication {
  type: ETypes;
  image: any;
  name: string;
  description: string;
  provider?: IntegrationProvider;
}

export const APPLICATIONS: IApplication[] = [
  {
    type: ETypes.PI,
    image: <PolandIcon />,
    name: "PI Sądów",
    description: "integrations.appPiDescription",
  },
  {
    type: ETypes.EMAIL,
    image: <OutlookIcon />,
    name: "Outlook",
    description: "integrations.outlookDescription",
    provider: IntegrationProvider.Microsoft,
  },
  {
    type: ETypes.EMAIL,
    image: <GmailIcon />,
    name: "Gmail",
    description: "integrations.gmailDescription",
    provider: IntegrationProvider.Google,
  },
  {
    type: ETypes.EMAIL,
    image: <ImapIcon />,
    name: "IMAP/POP3",
    description: "integrations.imapDescription",
    provider: IntegrationProvider.Imap,
  },
  {
    type: ETypes.CALENDAR,
    image: <MicrosoftIcon />,
    name: "Outlook calendar",
    description: "integrations.outlookCalendarDescription",
    provider: IntegrationProvider.Microsoft,
  },
  {
    type: ETypes.CALENDAR,
    image: <GoogleIcon />,
    name: "Google calendar",
    description: "integrations.googleCalendarDescription",
    provider: IntegrationProvider.Google,
  },
  {
    type: ETypes.CALENDAR,
    image: <AppleIcon />,
    name: "Apple calendar",
    description: "integrations.appleCalendarDescription",
    provider: IntegrationProvider.Apple,
  },
  {
    type: ETypes.EDITOR,
    image: <WordIcon />,
    name: "OFFICE 365",
    description: "integrations.office365Description",
  },
  {
    type: ETypes.EDITOR,
    image: <DocsIcon />,
    name: "Google docs",
    description: "integrations.googleDocsDescription",
    provider: IntegrationProvider.Google,
  },
  // { type: ETypes.FK, image: <FKIcon />, name: "wfirma", description: "" },
  {
    type: ETypes.KSEF,
    image: <KsefIcon />,
    name: "KSeF",
    description: "integrations.ksefName",
    provider: IntegrationProvider.KSeF,
  },
  {
    type: ETypes.CRU,
    image: <FontAwesomeIcon icon={faFileContract} style={{ fontSize: 28, color: "#5d49c7" }} />,
    name: "CRU",
    description: "integrations.cruName",
  },
];

const IntegrationMenu: FC<Props> = ({
  handleClick,
  refetchI,
  courtPortalState,
  handleDisconnect,
  onInnerViewCanceled,
  onInnerViewSaved,
  toggle,
  refetchportals,

  configureAppleCalendar,
  setConfigureAppleCalendar,
}) => {
  const { t } = useTranslation();

  const LIST = [
    { type: ETypes.ALL, name: t("integrations.allApps"), icon: <AllIcon /> },
    { type: ETypes.PI, name: t("settings.piCourts"), icon: <PIIcon /> },
    { type: ETypes.EMAIL, name: t("settings.tabs.email"), icon: <EmailIcon /> },
    { type: ETypes.CALENDAR, name: t("integrations.calendars"), icon: <CalendarIcon /> },
    { type: ETypes.EDITOR, name: t("integrations.editor"), icon: <LetterIcon /> },
    { type: ETypes.FK, name: t("integrations.fkSystem"), icon: <FKIcon /> },
  ];

  const [actual, setActual] = useState(0);
  const actualTab = LIST.at(actual);

  const [portals, setPortals] = useState(false);
  const [confImap, setConfImap] = useState(false);
  const [confKsef, setConfKsef] = useState(false);
  const [confCru, setConfCru] = useState(false);

  const ability = useContext(AbilityContext);

  let list = APPLICATIONS.filter(
    (x) => x.type !== ETypes.PI || ability.can("accessModule", "courtportal"),
  );

  if (actual !== 0) {
    list = APPLICATIONS.filter(
      (a) =>
        a.type === actualTab?.type &&
        (a.type !== ETypes.PI || ability.can("accessModule", "courtportal")),
    );
  }

  const onClick = (application: IApplication) => {
    logger.log("IntegrationMenu onClick", application);
    if (application.type === ETypes.PI) {
      const piAppIndex = LIST.findIndex((x) => x.type === ETypes.PI);
      setActual(piAppIndex);
      setPortals(true);
      return;
    }
    if (application.type === ETypes.EMAIL) {
      if (application.provider === IntegrationProvider.Google) {
        handleClick(IntegrationType.Email, IntegrationProvider.Google, false);
        return;
      }
      if (application.provider === IntegrationProvider.Microsoft) {
        handleClick(
          IntegrationType.Email,
          IntegrationProvider.Microsoft,
          false,
        );
        return;
      }
      if (application.provider === IntegrationProvider.Imap) {
        setConfImap(true);
        return;
      }
    }

    if (application.type === ETypes.CALENDAR) {
      if (application.provider === IntegrationProvider.Google) {
        handleClick(
          IntegrationType.Calendar,
          IntegrationProvider.Google,
          false,
        );
        return;
      } else if (application.provider === IntegrationProvider.Microsoft) {
        handleClick(
          IntegrationType.Calendar,
          IntegrationProvider.Microsoft,
          false,
        );
        return;
      } else if (application.provider === IntegrationProvider.Apple) {
        handleClick(IntegrationType.Calendar, IntegrationProvider.Apple, false);
        return;
      }
    }

    if (application.type === ETypes.EDITOR) {
      if (application.provider === IntegrationProvider.Google) {
        handleClick(IntegrationType.Editor, IntegrationProvider.Google, false);
        return;
      }
    }

    if (application.provider === IntegrationProvider.KSeF) {
      setConfKsef(true);
      return;
    }

    if (application.type === ETypes.CRU) {
      setConfCru(true);
      return;
    }
  };

  const Build = () => {
    if (confImap) {
      return (
        <ConfigureIMAP
          onSuccess={(email) => {
            refetchI();
            toggle();
          }}
          toggle={() => setConfImap(false)}
        />
      );
    }

    if (confKsef) {
      return (
        <ConfigureKSeF
          onSuccess={(nip) => {
            refetchI();
            toggle();
          }}
          toggle={() => setConfKsef(false)}
        />
      );
    }

    if (confCru) {
      return (
        <ConfigureCru
          onSuccess={() => {
            refetchI();
            toggle();
          }}
          toggle={() => setConfCru(false)}
        />
      );
    }

    if (configureAppleCalendar) {
      return (
        <ConfigureAppleCalendar
          onSuccess={(email) => {
            refetchI();
            toggle();
          }}
          toggle={() => setConfigureAppleCalendar(false)}
        />
      );
    }

    if (portals) {
      return (
        <CourtPortalSettings
          integrationId={courtPortalState.id}
          //  onCanceled={onInnerViewCanceled}
          onCanceled={() => {
            onInnerViewCanceled();
            setPortals(false);
          }}
          onSaved={() => {
            onInnerViewSaved();
            setPortals(false);
            toggle();
          }}
          handleDisconnect={handleDisconnect}
          refetchI={refetchI}
          refetchportals={refetchportals}
        ></CourtPortalSettings>
      );
    }

    return (
      <div className={styles.applications}>
        {list.map((a, index) => (
          <div
            onClick={() => onClick(a)}
            className={styles.application}
            key={"appInteg" + index}
          >
            <div className={styles.appIcon}>{a.image}</div>
            <div className={styles.appTitle}>{a.name}</div>
            <div className={styles.appDescription}>{t(a.description)}</div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <div onClick={toggle} className={styles.back}>
          <LeftArrow /> {t("settings.title")}
        </div>
        <div className={styles.list}>
          {LIST.filter(
            (x) =>
              x.type !== ETypes.PI ||
              ability.can("accessModule", "courtportal"),
          ).map((a, index) => (
            <div
              onClick={() => setActual(index)}
              className={`${styles.box} ${index === actual && styles.active}`}
            >
              {a.icon}
              {a.name}
            </div>
          ))}
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.header}>
          {actualTab?.icon} {actualTab?.name}
        </div>
        <div className={styles.listApplication}>{Build()}</div>
      </div>
    </div>
  );
};

export default IntegrationMenu;
